const initialState = {
    doctorPermissionsView: {},
    doctorListsView: [],
    doctorViewLists: [],
    doctorDetailListsView: [],
    doctorTypeDataView: [],
    doctorTypeView: [],
    hospitalListView: [],
    doctorStatusView: [],
    changedDoctorStatusView: [],
    changedDoctorTypeStatusView: [],
    createdDoctorIDView: '',
    doctorTypeCountView: 0,
    loadingDoctorView: false,
    loadingDoctorTypeView: false,
    loadingHospitalListView: false,
    loadingDoctorGrievanceView: false,
    loadingDoctorBlacklistView: false,
    loadingDoctorAlertView: false,
    errorsDoctorView: {},
    errorsDoctorTypeView: {},
    errorsDoctorRegisterView: {},
    errorsDoctorFacilityView: {},
    errorsSocialmediaView: {},
    errorsDoctorGrievanceView: {},
    errorsDoctorBlacklistView: {},
    errorsDoctorAlertView: {},
};

const doctorReducerView = (state = initialState, action) => {
    switch (action.type) {
        case "GET_DOCTORLIST_PENDING_VIEW":
        case "DOCTOR_TYPE_DATA_PENDING_VIEW":
            return { ...state, loadingDoctorTypeView: true, };
        case "HOSPITAL_LIST_PENDING_VIEW":
            return { ...state, loadingHospitalListView: true, };
        case "ADD_DOCTOR_TYPE_PENDING_VIEW":
            return { ...state, loadingDoctorTypeView: true, };
        case "UPDATE_DOCTOR_SOCIALMEDIA_PENDING_VIEW":
        case "ADD_DOCTOR_PENDING_VIEW":
        case "UPDATE_DOCTOR_PENDING_VIEW":
        case "DOCTOR_ATTACH_PENDING_VIEW":
        case "UPDATE_DOCTOR_STATUS_PENDING_VIEW":
        case "DELETE_DOCTOR_PENDING_VIEW":
        case "GET_DOCTORLISTBYID_PENDING_VIEW":
        case "GET_DOCTORVIEWBYID_PENDING":
            return { ...state, loadingDoctorView: true, errorsDoctorView: {} };
        case "GET_DOCTOR_DETAIL_LISTBYID_PENDING_VIEW":
            return { ...state, loadingDoctorView: true, errorsDoctorView: {} };
        case "DOCTOR_GRIEVANCE_PENDING_VIEW":
            return { ...state, loadingDoctorGrievanceView: true, errorsDoctorGrievanceView: {} };
        case "DOCTOR_BLACKLIST_PENDING_VIEW":
            return { ...state, loadingDoctorBlacklistView: true, errorsDoctorBlacklistView: {} };
        case "DOCTOR_ALERT_PENDING_VIEW":
            return { ...state, loadingDoctorAlertView: true, errorsDoctorAlertView: {} };
        case "DOCTOR_REGISTRATION_PENDING_VIEW":
            return { ...state, loadingDoctorView: true, errorsDoctorRegisterView: {} };

        case "GET_DOCTORLIST_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                doctorListsView: action.payload,
                doctorCountView: action.count,
                doctorPermissionsView: action.permissions,
            };

        case "DOCTOR_TYPE_DATA_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorTypeView: false,
                doctorTypeDataView: action.payload.data,
                doctorTypeCountView: action.count,
            };
        case "HOSPITAL_LIST_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalListView: false,
                hospitalListView: action.payload.data,
            };
        case "ADD_DOCTOR_TYPE_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorTypeView: false,
                changedDoctorTypeStatusView: action.payload,
                errorsDoctorTypeView: {},
            };

        case "ADD_DOCTOR_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: action.payload,
                doctorListsView: action.payload?.data,
                createdDoctorIDView: action.payload?.data?.id || state.createdDoctorIDView,
                errorsDoctorView: {},
            };
        case "UPDATE_DOCTOR_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: action.payload,
                doctorListsView: action.payload?.data,
                createdDoctorIDView: action.payload?.data?.id || state.createdDoctorIDView,
                errorsDoctorView: {},
            };

        case "UPDATE_DOCTOR_SOCIALMEDIA_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: action.payload,
                doctorListsView: action.payload?.data,
                createdDoctorIDView: action.payload?.data?.doctorId || state.createdDoctorIDView,
                errorsSocialmediaView: {},
            };

        case "DOCTOR_REGISTRATION_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: action.payload,
                doctorListsView: action.payload?.data,
                createdDoctorIDView: action.payload?.data?.doctorId || state.createdDoctorIDView,
                errorsDoctorRegisterView: {},
            };
        case "DOCTOR_ATTACH_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: action.payload,
                doctorListsView: action.payload?.data,
                createdDoctorIDView: action.payload?.data?.doctorId || state.createdDoctorIDView,
                errorsDoctorFacilityView: {},
            };
        case "DOCTOR_GRIEVANCE_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorGrievanceView: false,
                doctorListsView: action.payload?.data,
                changedDoctorStatusView: action.payload,
                errorsDoctorGrievanceView: {},
            };
        case "DOCTOR_BLACKLIST_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorBlacklistView: false,
                doctorListsView: action.payload?.data,
                changedDoctorStatusView: action.payload,
                errorsDoctorBlacklistView: {},
            };
        case "DOCTOR_ALERT_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorAlertView: false,
                doctorListsView: action.payload?.data,
                changedDoctorStatusView: action.payload,
                errorsDoctorAlertView: {},
            };
        case "UPDATE_DOCTOR_STATUS_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: action.payload,
                doctorListsView: action.payload?.data,
                createdDoctorIDView: action.payload?.data?.id || state.createdDoctorIDView,
            };
        case "RESET_CREATED_DOCTOR_ID":
            return {
                ...state,
                createdDoctorIDView: null,
            };

        case "GET_DOCTORLISTBYID_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                doctorListsView: action.payload,
            };

        case "GET_DOCTORVIEWBYID_FULFILLED":
            return {
                ...state,
                loadingDoctor: false,
                doctorViewLists: action.payload,
            };

        case "GET_DOCTOR_DETAIL_LISTBYID_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                doctorDetailListsView: action.payload,
            };

        case "DELETE_DOCTOR_FULFILLED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: action.payload,
            };

        case "RESET_DELETE_DOCTORS_STATUS_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                changedDoctorStatusView: [],
                errorsDoctorView: {},
            };

        case "GET_DOCTORLIST_REJECTED_VIEW":
        case "DOCTOR_TYPE_DATA_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorTypeView: false,
                errorsDoctorView: action.payload,
            };
        case "HOSPITAL_LIST_REJECTED_VIEW":
            return {
                ...state,
                loadingHospitalListView: false,
                errorsDoctorView: action.payload,
            };
        case "ADD_DOCTOR_TYPE_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorTypeView: false,
                changedDoctorTypeStatusView: [],
                errorsDoctorTypeView: action.payload,
            };
        case "ADD_DOCTOR_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                errorsDoctorView: action.payload,
            };
        case "UPDATE_DOCTOR_SOCIALMEDIA_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                errorsSocialmediaView: action.payload,
            };
        case "DOCTOR_REGISTRATION_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                errorsDoctorRegisterView: action.payload,
            };
        case "DOCTOR_ATTACH_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                errorsDoctorFacilityView: action.payload,
            };
        case "DOCTOR_GRIEVANCE_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorGrievanceView: false,
                errorsDoctorGrievanceView: action.payload,
            };
        case "DOCTOR_BLACKLIST_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorBlacklistView: false,
                errorsDoctorBlacklistView: action.payload,
            };
        case "DOCTOR_ALERT_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorAlertView: false,
                errorsDoctorAlertView: action.payload,
            };
        case "UPDATE_DOCTOR_REJECTED_VIEW":
        case "UPDATE_DOCTOR_STATUS_REJECTED_VIEW":
        case "DELETE_DOCTOR_REJECTED_VIEW":
        case "GET_DOCTORLISTBYID_REJECTED_VIEW":
        case "GET_DOCTORVIEWBYID_REJECTED":
            return {
                ...state,
                loadingDoctorView: false,
                errorsDoctorView: action.payload,
            };
        case "GET_DOCTOR_DETAIL_LISTBYID_REJECTED_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                errorsDoctorView: action.payload,
            };
        case "RESET_DELETE_DOCTOR_STATUS_VIEW":
            return {
                ...state,
                loadingDoctorView: false,
                loadingDoctorTypeView: false,
                loadingHospitalListView: false,
                loadingDoctorGrievanceView: false,
                loadingDoctorBlacklistView: false,
                loadingDoctorAlertView: false,
                errorsDoctorView: {},
                errorsDoctorTypeView: {},
                errorsDoctorRegisterView: {},
                errorsDoctorFacilityView: {},
                errorsSocialmediaView: {},
                errorsDoctorGrievanceView: {},
                errorsDoctorBlacklistView: {},
                errorsDoctorAlertView: {},
            };
        case "RESET_DOCTOR_STATE_VIEW":
            return { ...initialState };

        default:
            return state;
    }
};

export default doctorReducerView;
